import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	cardTitle: {
		id: 'servicedesk.knowledge-hub.virtual-service-agent-cta-card.title.nonFinal',
		defaultMessage: 'Virtual service agent',
		description: 'Title for the virtual service agent cta card',
	},
	inactiveLabel: {
		id: 'servicedesk.knowledge-hub.virtual-service-agent-cta-card.inactive.nonFinal',
		defaultMessage: 'Inactive',
		description: 'Label for the virtual service agent cta card when the virtual agent is inactive',
	},
	activeLabel: {
		id: 'servicedesk.knowledge-hub.virtual-service-agent-cta-card.active.nonFinal',
		defaultMessage: 'Active',
		description: 'Label for the virtual service agent cta card when the virtual agent is active',
	},
	cardDescription: {
		id: 'servicedesk.knowledge-hub.virtual-service-agent-cta-card.description.nonFinal',
		defaultMessage: 'Use your knowledge base and AI to respond to customer questions.',
		description:
			'Description for the virtual service agent cta card when virtual agent is inactive',
	},
	turnOnAiAnswersCta: {
		id: 'servicedesk.knowledge-hub.virtual-service-agent-cta-card.cta.inactive.nonFinal',
		defaultMessage: 'Turn on AI Answers',
		description:
			'Call to action for the virtual service agent cta card when the virtual service agent is inactive',
	},
	turnOnVsaCta: {
		id: 'servicedesk.knowledge-hub.virtual-service-agent-cta-card.cta.turnOnVsa.nonFinal',
		defaultMessage: 'Turn on Virtual Service Agent',
		description:
			'Call to action for the virtual service agent cta card when the virtual service agent does not exist',
	},
	manageCta: {
		id: 'servicedesk.knowledge-hub.virtual-service-agent-cta-card.cta.active.nonFinal',
		defaultMessage: 'Manage',
		description:
			'Call to action for the virtual service agent cta card when the virtual service agent is active',
	},
});
